import { UPDATE_SURVEY_ANSWERS } from '../constants/actionLocal';
import initialState from '../store/initialState';
import { updateObjectInState } from '../helpers/data';

export default (state = initialState.surveyAnswers, { type, payload }) => {
  switch (type) {
    case UPDATE_SURVEY_ANSWERS:
      return updateObjectInState(state, payload);
    default:
      return state;
  }
};
